import { useCallback } from "react";
import ReactGA from "react-ga4";

interface AnalyticsEvent {
  action: string;
  category?: string;
  label?: string;
  value?: number;
}

export const useAnalytics = () => {
  const trackEvent = useCallback((event: AnalyticsEvent) => {
    try {
      ReactGA.event({
        action: event.action,
        category: event.category || "general",
        label: event.label,
        value: event.value,
      });

      console.log("📊 Analytics event tracked:", event);
    } catch (error) {
      console.error("❌ Error tracking analytics event:", error);
    }
  }, []);

  const trackPageView = useCallback((path: string, title?: string) => {
    try {
      ReactGA.send({
        hitType: "pageview",
        page: path,
        title: title || document.title,
      });

      console.log("📊 Analytics page view tracked:", {
        path,
        title: title || document.title,
      });
    } catch (error) {
      console.error("❌ Error tracking page view:", error);
    }
  }, []);

  const trackUserAction = useCallback(
    (action: string, details?: Record<string, unknown>) => {
      trackEvent({
        action,
        category: "user_interaction",
        label: details?.label as string,
        value: details?.value as number,
      });
    },
    [trackEvent],
  );

  return { trackEvent, trackPageView, trackUserAction };
};
